import { apiGet } from 'helpers/ApiHelper';

import Auth from 'j-toker';
import { toDate } from 'helpers/Formatter';

import * as notifications from './notificationActions';

export function getLeaseDocumentDetails(lease_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leases_documents/${lease_id}`)
        .done(response => {
          dispatch({
            type: 'LANDLORD::SAVE_LEASE_DOCUMENT_DETAILS',
            leaseDocumentDetails: response.lease_document_details,
          });
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function openEditLease(lease_id) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD::GET_LEASE_DETAILS',
      payload: apiGet(Auth.getApiUrl() + `/landlords/leases/${lease_id}`)
        .done(response => {
          dispatch(saveLeaseDetails(response.lease_details));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

function saveLeaseDetails(leaseDetails) {
  if (leaseDetails) {
    leaseDetails.early_move_in_date = toDate(leaseDetails.early_move_in_date);
    leaseDetails.lease_end_date = toDate(leaseDetails.lease_end_date);
    leaseDetails.lease_start_date = toDate(leaseDetails.lease_start_date);
  }
  return {
    type: 'LANDLORD::SAVE_LEASE_DETAILS',
    leaseDetails,
  };
}

export function clearLeaseDetails() {
  const leaseDetails = {};

  return {
    type: 'LANDLORD::SAVE_LEASE_DETAILS',
    leaseDetails,
  };
}
